import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, Result, Radio, Space, Grid } from 'antd';
import { Button } from 'antd';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeContainer,
	XThemeFilterCards,
	XThemeInputText,
	XThemeFilterButton,
	XThemeFilterCircleButton,
	XThemeSelect,
	XThemeRadio,
	XEditButtonIcon,
} from '../../styles/GlobalThemeStyle';

import CaseSearch from '../../components/CaseSearch/CaseSearch';
// actions
import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';
import {
	getStateDropdownApi,
	getStateDropdownReset,
} from '../../actions/getStateDropdownAction';
import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { XButtonImg } from '../Manage/ManageStyle';
import { filterByLabel } from '../../utils/formFunctions';
import { XTheme2InnerCard, XTheme2Para1 } from '../Dashboard/DashboardStyleCQ';
import {
	XTheme2Button,
	XTheme2InputText,
	XTheme2MainTitle,
} from '../../styles/GlobalThemeStyleCQ';

const Organization = (props) => {
	const {
		getOrganizations,
		getOrganizationsState,
		getStateDropdown,
		getStateDropdownState,
	} = props;
	const defaultFilters = {
		search: '',
		page: 1,
		sort: 'updatedAt',
		sortDirection: 'descend',
		created_on: 'all',
		state: '',
		limit: 10,
		region: '',
	};
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [totalRecords, setTotalRecords] = useState('');
	const getFiltersFromUrl = () => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlFilters = {};

		// Iterate through each query parameter and set it in the state
		for (const [key, value] of urlParams.entries()) {
			urlFilters[key] = value;
		}

		// Merge with default filters or initial state as needed
		const filters = {
			...defaultFilters, // Replace with your default filters
			...urlFilters,
		};

		return filters;
	};
	const initialFilters = getFiltersFromUrl();

	const [filters, setFilters] = useState(initialFilters);

	const [form2] = XThemeForm.useForm();

	const [open, setOpen] = useState(false);

	const showDrawer = () => {
		setOpen(true);
	};
	const onClose = () => {
		setOpen(false);
	};

	const onChange = (key) => {
		setFilters({
			...filters,
			[key.target.name]: key.target.value,
		});
	};

	const columns = [
		{
			title: 'Name',
			width: 200,
			dataIndex: 'name',
			fixed: 'left',
			render: (name) => (
				<div>
					<div>{name}</div>
				</div>
			),
		},
		{
			title: 'Contact Person',
			width: 200,
			dataIndex: 'contact_person',
			render: (contact_person) => (
				<div>
					<div>{contact_person}</div>
				</div>
			),
		},
		{
			title: 'Mobile Number',
			width: 200,
			dataIndex: 'contact_person_mobile_number',
			render: (contact_person_mobile_number) => (
				<div>
					<div>{contact_person_mobile_number}</div>
				</div>
			),
		},
		{
			title: 'Email Address',
			width: 200,
			dataIndex: 'contact_person_email_address',
			render: (contact_person_email_address) => (
				<div>
					<div>{contact_person_email_address}</div>
				</div>
			),
		},
		{
			title: 'Address',
			width: 300,
			dataIndex: 'address',
			render: (address) => (
				<div>
					<div>{address}</div>
				</div>
			),
		},
		{
			title: 'State',
			width: 150,
			dataIndex: 'state',
			render: (state) => (
				<div>
					<div>{state}</div>
				</div>
			),
		},
		{
			title: 'Action',
			width: 150,
			dataIndex: 'action',
			align: 'center',
			fixed: 'right',
		},
	];

	const handleEdit = (item) => {
		navigate(`/organization/edit/${item._id}`);
	};

	// use effects

	useEffect(() => {
		if (getOrganizationsState.apiState === 'success') {
			if (getOrganizationsState.data.list.length > 0) {
				const updatedData = [];
				const updatedSearchOptions = [];
				setTotalRecords(getOrganizationsState.data.total_count);
				getOrganizationsState.data.list.map((item, index) => {
					updatedSearchOptions.push({ value: item.name });
					updatedData.push({
						key: item._id,
						_id: item._id,
						name: item.name,
						contact_person: item.contact_person,
						contact_person_email_address:
							item.contact_person_email_address,
						contact_person_mobile_number:
							item.contact_person_mobile_number,
						fax_number: item.fax_number,
						address: item.address
							? truncateString(item.address, 30)
							: '',
						state: item.state,
						action: (
							<div className="text-center">
								<XEditButtonIcon
									onClick={() => {
										handleEdit(item);
									}}
									type="text"
								>
									<img src="./images/pencil.svg" alt="" />
								</XEditButtonIcon>
							</div>
						),
					});
				});
				setTableData(updatedData);
			} else {
				setTableData([]);
				setTotalRecords(0);
			}
		}
	}, [getOrganizationsState]);

	const applyFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through filters and update the query parameters
		Object.entries(filters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the current value
				queryParams.append(key, value);
			}
		});

		// Set the page to 1
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');
		filters.page = 1;

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};

	useEffect(() => {
		// Retrieve filters from the updated URL
		const updatedFilters = getFiltersFromUrl();
		setFilters({ ...updatedFilters });

		// Make API call with updated filters and pagination
		checkModulePermissions('organization-management').sub_modules.includes(
			'list-organizations',
		) && getOrganizations({ ...updatedFilters });
	}, [window.location.search]);

	const clearFilters = () => {
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate through defaultFilters and update the query parameters
		Object.entries(defaultFilters).forEach(([key, value]) => {
			const currentValue = queryParams.get(key);

			// Check if the parameter exists in the current query and has a value, if yes, update its value
			if (currentValue !== null) {
				queryParams.set(key, value);
			} else if (queryParams.has(key)) {
				// If the parameter exists but has no value, keep its existing value
				queryParams.set(key, queryParams.get(key));
			} else {
				// If the parameter does not exist in the current query, append it with the default value
				queryParams.append(key, value);
			}
		});

		// Clear the form fields
		form2.resetFields();

		// Update the state with default values
		setFilters(defaultFilters);

		// Update the URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
		window.history.pushState({}, '', newUrl);
	};
	const { useBreakpoint } = Grid;
	const screens = useBreakpoint();
	const isMobile = !screens.md;
	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Organization" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="organization" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				{checkModulePermissions('organization-management')
					.authorized ? (
					<>
						<Row
							gutter={[15, 15]}
							className="align-items-center mb-4"
						>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-start"
							>
								<XTheme2MainTitle className="mb-2">
									Organization Management
								</XTheme2MainTitle>
								<XTheme2Para1>
									View and manage organizations
								</XTheme2Para1>
							</Col>
							<Col
								xs={24}
								sm={24}
								md={12}
								lg={12}
								xl={12}
								className="text-center text-md-end"
							>
								<>
									{isMobile ? (
										<XTheme2Button
											shape="circle"
											size="large"
											className="noBackground borderColor"
											icon={<PlusOutlined />}
											onClick={() =>
												navigate('/organization/add')
											}
										/>
									) : (
										<Link to="/organization/add">
											<XTheme2Button
												size="large"
												icon={<PlusOutlined />}
											>
												Add Organization
											</XTheme2Button>
										</Link>
									)}
								</>
							</Col>
						</Row>

						<XTheme2InnerCard
							className="mb-3"
							bodyStyle={{ padding: '20px 0px' }}
						>
							<div className="smallTopBottomPadding mb-3 px-4">
								<CaseSearch
									filters={[
										<XThemeForm.Item
											name="state"
											colon={false}
											label="HQ State"
											className="drawerlabel"
										>
											<XThemeSelect
												size="large"
												allowClear
												className="noBorderRadius"
												placeholder="Select State"
												onFocus={() => {
													getStateDropdown();
												}}
												// onSearch={(search) => {
												// 	if (search.length >= 3) {
												// 		getStateDropdown({
												// 			search,
												// 		});
												// 	} else if (search.length === 0) {
												// 		getStateDropdown();
												// 	}
												// }}
												onClear={() => {
													setFilters({
														...filters,
														state: '',
														insurance_company: '',
													});
												}}
												showSearch={true}
												filterOption={filterByLabel}
												options={
													getStateDropdownState.apiState ===
														'success' &&
													getStateDropdownState.data
														.all_states?.length >
														0 &&
													getStateDropdownState.data.all_states.map(
														(itm) => {
															return {
																label: itm.state,
																value: itm.state,
																providers:
																	itm.providers,
															};
														},
													)
												}
												onSelect={(value, options) => {
													setFilters({
														...filters,
														state: value,
													});
												}}
											/>
										</XThemeForm.Item>,
										<XThemeForm.Item
											name="created_on"
											colon={false}
											label="Date Within"
											className="drawerlabel"
										>
											<XThemeRadio.Group
												onChange={onChange}
												name="created_on"
											>
												<Row>
													{dateFilters.map(
														(item, index) => (
															<Col
																xs={12}
																lg={12}
																md={12}
																xl={12}
															>
																<XThemeRadio
																	value={
																		item.value
																	}
																>
																	{item.label}
																</XThemeRadio>
															</Col>
														),
													)}
												</Row>
											</XThemeRadio.Group>
										</XThemeForm.Item>,
									]}
									onClose={onClose}
									open={open}
									applyFilters={applyFilters}
									form={form2}
									clearFilters={clearFilters}
								/>
								<Row
									gutter={(15, 15)}
									className="align-items-center"
								>
									<Col xs={16} sm={16} md={6} lg={6}>
										<h1
											className="cardTitle mb-0"
											style={{ fontSize: '18px' }}
										>
											Total {totalRecords} Organizations
										</h1>
									</Col>
									<Col
										xs={24}
										sm={16}
										md={12}
										lg={12}
										className="d-none d-md-block"
									>
										<Space>
											<XTheme2InputText
												size="large"
												allowClear
												placeholder="Search for Organizations"
												defaultValue={
													filters.search
														? filters.search
														: null
												}
												onChange={(v) => {
													if (v.target.value === '') {
														getOrganizations({
															...filters,
															search: '',
														});
													} else {
														setFilters({
															...filters,
															search: v.target
																.value,
														});
													}
												}}
												onKeyDown={(e) => {
													if (e.key === 'Enter') {
														const searchValue =
															filters.search
																? filters.search
																: '';
														if (searchValue) {
															getOrganizations({
																...filters,
																search: searchValue,
															});
															setFilters({
																...filters,
																search: searchValue,
															});
														}
													}
												}}
											/>
											<XTheme2Button
												onClick={() => {
													// Trigger search when the button is clicked
													const searchValue =
														filters.search
															? filters.search
															: '';
													if (searchValue) {
														getOrganizations({
															...filters,
															search: searchValue,
														});
														setFilters({
															...filters,
															search: searchValue,
														});
													}
												}}
											>
												Search
											</XTheme2Button>
										</Space>
									</Col>
									<Col
										xs={8}
										sm={8}
										md={6}
										lg={6}
										className="text-end"
									>
										<Space>
											<XTheme2Button
												className="noBackground borderColor"
												shape="circle"
												size="large"
												onClick={() => showDrawer()}
												icon={
													<img
														src="/images/theme-filter-icon.svg"
														alt="filter"
													/>
												}
											/>

											{/* <XThemeFilterButton
												className="backgroundRevers"
												onClick={() =>
													navigate(
														'/organization/add',
													)
												}
												icon={<PlusCircleFilled />}
											>
												Organization
											</XThemeFilterButton> */}
										</Space>
									</Col>
								</Row>
							</div>

							<DataTable
								tableData={tableData}
								columns={columns}
								totalRecords={totalRecords}
								setFilters={setFilters}
								filters={filters}
								state={getOrganizationsState.apiState}
								page={'organization'}
								handleEdit={handleEdit}
							/>
						</XTheme2InnerCard>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
		</>
	);
};

const mapStateToProps = (state) => ({
	getOrganizationsState: state.getOrganizations,
	getStateDropdownState: state.getStateDropdown,
});

const mapDispatchToProps = (dispatch) => ({
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
	getOrganizationsReset: () => dispatch(getOrganizationsReset()),
	getStateDropdown: (params) => dispatch(getStateDropdownApi(params)),
	getStateDropdownReset: () => dispatch(getStateDropdownReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Organization);
